const CheckboxList = ({ stringList, inputDataKey, inputDataValue, returnFunction }) => {
    return (
        <div className="flex flex-col ">
            {
                stringList && stringList.length > 0 && stringList.map((element, index) => {
                    return <div key={index} className={`border rounded p-2 ${inputDataValue.includes(stringList[index]['label']) ? 'border-[#225424]' : ''}`}>
                        <input className="mr-2" onChange={returnFunction} type="checkbox" value={element.name} id={inputDataKey + (index + 1)} checked={inputDataValue.includes(stringList[index]['name']) ? true : false} />
                        <label className="text-xs">{stringList[index]['name']}</label></div>
                })
            }
        </div>
    )
}

export default CheckboxList;